module.exports = __webpack_public_path__ + "img/dianhua-weijiaohuan@3x.c3497d9a.svg";